// extracted by mini-css-extract-plugin
module.exports = {"hm":"styles_hm__8PHmx","logo":"styles_logo__G5EmJ","btn":"styles_btn__yf1Oi","security":"styles_security__DcWtn","feature":"styles_feature__sgqJO"};